import React from "react";
import { CompanyListTableReference } from "models/AiResearch";
import styles from "./style.scss";
import DownloadImage from "images/icon/download.svg";

export const CompanyListTable: React.FC<{
  reference: CompanyListTableReference;
}> = ({ reference }) => {
  const data = reference.data.content.values.slice(0, 10);
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  // CSVダウンロード
  const onDownloadCsv = () => {
    const { header, name } = reference.data.content;

    const escapeCsvValue = (value: string | number | null | undefined) => {
      const text = value == null ? "" : String(value);
      if (/[",\n\r]/.test(text)) {
        return `"${text.replace(/"/g, '""')}"`;
      }
      return text;
    };

    const rows = [header, ...reference.data.content.values];
    const csvBody = rows
      .map(row => row.map(escapeCsvValue).join(","))
      .join("\r\n");
    const csvContent = `\uFEFF${csvBody}`;

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    const safeName = (name || "company-list").replace(/[\\/:*?"<>|]/g, "_");
    anchor.href = url;
    anchor.download = `${safeName}.csv`;
    const attachTarget =
      (containerRef.current as Node | null) ||
      (document.body as Node | null) ||
      (document.documentElement as Node | null);
    if (attachTarget) {
      attachTarget.appendChild(anchor);
    }
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className={styles.container} ref={containerRef}>
      <span className={styles.citationNumber}>{reference.citationNumber}</span>
      <p>以下の条件でデータベースを検索しています。</p>
      <div className={styles.conditions}>
        <div>
          <div className={styles.conditionLabel}>条件：</div>
          {reference.data.meta.searchConditionsSummary.conditions.map(
            (condition, index) => {
              return (
                <div key={index} className={styles.item}>
                  <div>{condition.clauseLabel}：</div>
                  {condition.conditions.map((child, index) => {
                    return (
                      <div key={`child-${index}`} className={styles.child}>
                        {child.fieldLabel}：{child.valueLabels.join("、")}
                      </div>
                    );
                  })}
                </div>
              );
            }
          )}
        </div>
        <div>
          <span className={styles.conditionLabel}>ソート：</span>
          {reference.data.meta.searchConditionsSummary.sort.map(
            (sort, index) => {
              return (
                <span key={index}>
                  {sort.fieldLabel}の{sort.orderLabel}
                </span>
              );
            }
          )}
        </div>
        <div>
          <span className={styles.conditionLabel}>上限：</span>
          {reference.data.meta.searchConditionsSummary.sizeLimit}件
        </div>
      </div>
      <div className={styles.resultInfo}>
        <button
          className={styles.downloadButton}
          onClick={onDownloadCsv}
          data-reference-button
        >
          <img src={DownloadImage} />
          CSVダウンロード
        </button>
        <div className={styles.resultCount}>
          {data.length}件表示 / 全{reference.data.meta.total}件
        </div>
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.vsTable}>
          <thead>
            <tr>
              {reference.data.content.header.map((header, index) => {
                return <th key={index}>{header}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((value, index) => {
              return (
                <tr key={index}>
                  {value.map((v, index) => {
                    return <td key={index}>{v}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
